export default __webpack_public_path__ + "static/media/borderchank.f2a5148c.svg";